import { createContext, useContext } from "react";

const TabsContext = createContext();

export const TabContextProvider = ({ value, children }) => {
  return (
    <TabsContext.Provider value={{ value }}>{children}</TabsContext.Provider>
  );
};

export const useTabContext = () => useContext(TabsContext);
